import { Map } from 'immutable'
import * as React from 'react'
import { fromJSX, Updater, Widget } from 'widgets-for-react'
import { cookieBar_layout } from './cookiebar.layout.mod'
import { CookieAccepted, CookiebarState, CookieName, CookieState } from './cookiebar.types.mod'
import { getCookie, setCookie } from './cookiebar.utils.mod'
import i18next = require('i18next')

const _cookieBar_layout = cookieBar_layout()

let cookiebar_state_zero = (props: {
  cookie_names: CookieName[]
  labels: Map<CookieName, string>
  htmlFor: Map<CookieName, string>
  readonly_cookies?: CookieName[]
  required_cookies?: CookieName[]
}): CookiebarState => {
  let Cookies: Map<CookieName, CookieState> = Map<CookieName, CookieState>()
  let is_in = (c: CookieName, c_list: CookieName[]) => {
    if (c_list == undefined) return false
    return c_list.find((c1) => c == c1) != undefined
  }
  let is_in2 = (c: CookieName, c_list: Map<CookieName, string>) => {
    if (c_list == undefined) return ''
    if (c_list.has(c)) return c_list.get(c)
    return ''
  }
  props.cookie_names.forEach((cookie_name) => {
    let isAccepted: CookieAccepted =
      getCookie(cookie_name) == 'yes' || is_in(cookie_name, props.readonly_cookies) ? 'yes' : 'no'
    Cookies = Cookies.set(cookie_name, {
      isAccepted,
      isDisabled: is_in(cookie_name, props.readonly_cookies),
      isRequired: is_in(cookie_name, props.required_cookies),
      label: is_in2(cookie_name, props.labels),
      htmlFor: is_in2(cookie_name, props.htmlFor)
    })
  })

  return {
    Cookies,
    tmp_Cookies: Cookies.toMap(),
    ExpandOptions: false,
    CookieBarVisible: should_show_cookies()
  }
}

export let make_empty_cookie_state_zero = () =>
  cookiebar_state_zero({
    cookie_names: ['functional', 'analytics', 'video-cookies', 'marketing'],
    htmlFor: Map({
      'functional': 'cookie-functional',
      'analytics': 'cookie-analytics',
      'video-cookies': 'cookie-video',
      'marketing': 'cookie-marketing'
    }),
    labels: Map({
      'functional': `${i18next.t('Cookies:CookieBar:Functional')}: ${i18next.t('Cookies:CookieBar:FunctionalCookies')}`,
      'analytics': `${i18next.t('Cookies:CookieBar:Analytical')}: ${i18next.t('Cookies:CookieBar:AnalyticalCookies')}`,
      'video-cookies': `${i18next.t('Cookies:CookieBar:Videos')}: ${i18next.t('Cookies:CookieBar:VideosCookies')}`,
      'marketing': `${i18next.t('Cookies:CookieBar:Tracking')}: ${i18next.t('Cookies:CookieBar:TrackingCookies')}`
    }),
    readonly_cookies: ['functional', 'analytics'],
    required_cookies: ['functional', 'analytics']
  })
let should_show_cookies = () => {
  return getCookie('show_cookies') != 'no'
}

export let are_cookies_different = (c1: CookiebarState, c2: CookiebarState) => {
  let answer = true
  c1.Cookies.forEach((v, n) => {
    if (c2.Cookies.get(n).isAccepted != v.isAccepted) {
      answer = false
    }
  })
  return !answer
}

export let is_cookie_accepted = (cookie_name: CookieName): boolean => {
  return getCookie(cookie_name) == 'yes'
}

export let cookiebar = (
  state: CookiebarState,
  show_single_cookie: CookieName = undefined,
  cookiesPlaceholderClassName?: string
): Widget<Updater<CookiebarState>> => {
  return fromJSX<Updater<CookiebarState>>((setState) => {
    let apply_tmp_cookies = () =>
      setState((state) => {
        state.tmp_Cookies.forEach((v, n) => {
          setCookie(n, v.isAccepted, 1000)
        })
        setCookie('show_cookies', 'no', 1000)
        let should_reload_page = false
        state.tmp_Cookies.forEach((v, k) => {
          if (state.Cookies.has(k) && state.Cookies.get(k).isAccepted == 'yes' && v.isAccepted == 'no') {
            should_reload_page = true
          }
        })
        if (should_reload_page) {
          location.reload()
          return { ...state, CookieBarVisible: false }
        }
        return {
          ...state,
          Cookies: state.tmp_Cookies.toMap(),
          CookieBarVisible: false
        }
      })
    let apply = (cookieAccepted: CookieAccepted) => () =>
      setState((state) => {
        setCookie('show_cookies', 'no', 1000)
        let updated_cookies: Immutable.Map<CookieName, CookieState> = state.Cookies.map((c_value, c_name) => {
          setCookie(c_name, cookieAccepted, 1000)
          return { ...c_value, isAccepted: cookieAccepted }
        }).toMap()
        if (cookieAccepted == 'yes') {
          window.dataLayer.push({
            event: `event.${sitename}`,
            category: 'Cookies',
            action: 'Accept',
            label: window.location.pathname
          })
        }
        if (cookieAccepted == 'no') {
          window.dataLayer.push({
            event: `event.${sitename}`,
            category: 'Cookies',
            action: 'Decline',
            label: window.location.pathname
          })
          location.reload()
          return { ...state, CookieBarVisible: false }
        }
        return {
          ...state,
          Cookies: updated_cookies,
          CookieBarVisible: false
        }
      })
    let apply_single = (c_name: CookieName, c_value: CookieAccepted, use_tmp) =>
      setState((state) => {
        if (use_tmp) {
          let cookie = state.tmp_Cookies.get(c_name)
          if (cookie == undefined) console.error('missing cookie in state', c_name)
          let updated_cookies: Immutable.Map<CookieName, CookieState> = state.tmp_Cookies.set(c_name, {
            ...cookie,
            isAccepted: c_value
          })
          return {
            ...state,
            tmp_Cookies: updated_cookies
          }
        } else {
          setCookie(c_name, c_value, 1000)
          let cookie = state.Cookies.get(c_name)
          if (cookie == undefined) console.error('missing cookie in state', c_name)
          let updated_cookies: Immutable.Map<CookieName, CookieState> = state.Cookies.set(c_name, {
            ...cookie,
            isAccepted: c_value
          })
          return {
            ...state,
            Cookies: updated_cookies,
            tmp_Cookies: updated_cookies
          }
        }
      })

    if (show_single_cookie != undefined) {
      return (
        <_cookieBar_layout.cookiebar_single
          accept={() => apply_single(show_single_cookie, 'yes', false)}
          caption_accept={i18next.t('Cookies:CookiesPlaceholder:AcceptCookies')}
          title={i18next.t('Cookies:CookiesPlaceholder:Text')}
          className={cookiesPlaceholderClassName}
        />
      )
    }
    if (!state.CookieBarVisible) return <></>
    return (
      <_cookieBar_layout.cookiebar
        collapse_cookiebar={() => setState((state) => ({ ...state, CookieBarVisible: false }))}
        accept_all={apply('yes')}
        caption_accept_all={i18next.t('Cookies:CookieBar:AcceptCookies')}
        caption_decline_all={i18next.t('Cookies:CookieBar:DeclineCookies')}
        decline_all={apply('no')}
        apply_settings={apply_tmp_cookies}
        caption_apply_settings={i18next.t('Cookies:CookieBar:ChangeSettings')}
        set_single={(name, value) => apply_single(name, value, true)}
        show_options={state.ExpandOptions}
        show_options_toggle={() => setState((s) => ({ ...s, ExpandOptions: !s.ExpandOptions }))}
        show_options_label={i18next.t('Cookies:CookieBar:ShowOptions')}
        title={i18next.t('Cookies:CookieBar:Title')}
        text={i18next.t('Cookies:CookieBar:Text')}
        state={state.tmp_Cookies
          .map((cv, cn): [string, CookieState] => [cn, cv])
          .valueSeq()
          .toList()}
      />
    )
  })
}
